import { useState, useEffect, useContext } from 'react'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import DeleteIcon from '@mui/icons-material/Delete'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { getTopThreeFromWidgetRef } from '../../helpers/remoteData'
import { ClientContext } from '../../providers/ClientProvider'
import AttachmentsModal from './components/AttachmentsModal'

function SmartsheetSummaryDirectMailWidget({ reference, pageUrl, isAdmin, setSelectedWidget, el, moveUp, moveDown }) {
  const { client } = useContext(ClientContext)

  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState<Array<any>>([])
  const [attachments, setAttachments] = useState<Array<any>>([])

  useEffect(() => {
    const _fetch = async () => {
      setLoading(true)

      try {
        const _rows = await getTopThreeFromWidgetRef(reference, 'dropDate')

        if (_rows) {
          setRows(_rows)
        }

        setLoading(false)
      }
      catch (e) {
        console.log('Direct Mail Error')
        
        setRows([])
        setLoading(false)
      }
    }

    _fetch()
  }, [reference])

  return (
    <div className='col-12 col-md-6 col-xl-4 mb-8 d-inline-block'>
      <div className='card shadow h-100'>
        {
          isAdmin && (
            <div className='card-header justify-content-end'>
              <button
                type='button'
                className='btn btn-link btn-sm btn-color-muted btn-color-active-muted d-inline-flex align-items-center justify-content-between mx-2 my-1'
                onClick={() => moveUp(el)}
              >
                <ArrowUpwardIcon />
              </button>
              <button
                type='button'
                className='btn btn-link btn-sm btn-color-muted btn-color-active-muted d-inline-flex align-items-center justify-content-between mx-2 my-1'
                onClick={() => moveDown(el)}
              >
                <ArrowDownwardIcon />
              </button>
              <button
                type='button'
                className='btn btn-link btn-sm btn-color-muted btn-color-active-muted d-inline-flex align-items-center justify-content-between mx-2 my-1'
                data-bs-toggle='modal'
                data-bs-target='#modal_delete_widget'
                onClick={() => setSelectedWidget(el)}
              >
                <DeleteIcon />
              </button>
            </div>
          )
        }
        {
          loading ? 
            <div className='card-body text-center'>
              <div className='spinner-border spinner-border-sm' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          :
            <div className='card-body'>
              <h4 className='d-flex align-items-center mb-0 fw-boldest'>
                <span className='me-3'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6.22501 3.65991L9.90001 5.12991H12.72L6.12001 2.48991C5.85001 2.38491 5.55001 2.50491 5.44501 2.77491L4.50001 5.12991H5.62501L6.22501 3.65991ZM23.13 9.46491C23.07 9.32991 22.965 9.23991 22.845 9.17991L21.69 8.71491V9.83991L21.975 9.95991L21.69 10.6649V13.4699L23.145 9.86991C23.19 9.73491 23.19 9.59991 23.13 9.46491ZM0.870014 14.5349C0.930014 14.6699 1.03501 14.7599 1.15501 14.8199L2.31001 15.2849V14.1599L2.02501 14.0399L2.31001 13.3349V10.5299L0.855014 14.1299C0.810014 14.2649 0.810014 14.3999 0.870014 14.5349ZM17.775 20.3399L14.1 18.8699H11.265L17.865 21.5099C17.925 21.5399 18 21.5549 18.06 21.5549C18.27 21.5549 18.465 21.4349 18.54 21.2249L19.485 18.8699H18.345L17.775 20.3399ZM20.79 5.50491H3.21001C2.92501 5.50491 2.68501 5.74491 2.68501 6.02991V17.9699C2.68501 18.2549 2.92501 18.4949 3.21001 18.4949H20.775C21.06 18.4949 21.3 18.2549 21.3 17.9699V6.02991C21.315 5.74491 21.075 5.50491 20.79 5.50491ZM20.265 17.4449H3.73501V6.55491H20.25V17.4449H20.265Z" fill={client?.defaultColor ? client.defaultColor : '#F288B7'}/>
                    <path d="M16.485 9.99011L16.575 10.2001L16.47 10.5451C16.425 10.6801 16.47 10.8451 16.575 10.9351C16.68 11.0401 16.845 11.0551 16.98 10.9951L17.115 10.9351L17.25 10.9951C17.355 11.0401 17.46 11.0401 17.565 10.9951L17.7 10.9351L17.835 10.9951C17.94 11.0401 18.045 11.0401 18.15 10.9951L18.285 10.9351L18.42 10.9951C18.525 11.0401 18.63 11.0401 18.735 10.9951L18.87 10.9351L19.005 10.9951C19.05 11.0251 19.11 11.0251 19.17 11.0251C19.26 11.0251 19.35 10.9951 19.41 10.9351C19.515 10.8301 19.56 10.6801 19.515 10.5451L19.41 10.2001L19.5 9.99011C19.545 9.90011 19.545 9.78011 19.5 9.69011L19.41 9.49511L19.5 9.30011C19.545 9.21011 19.545 9.09011 19.5 9.00011L19.41 8.80511L19.5 8.61011C19.545 8.52011 19.545 8.40011 19.5 8.31011L19.41 8.10011L19.515 7.75511C19.56 7.62011 19.515 7.45511 19.41 7.36511C19.305 7.26011 19.14 7.24511 19.005 7.30511L18.87 7.36511L18.735 7.30511C18.63 7.26011 18.525 7.26011 18.42 7.30511L18.285 7.36511L18.15 7.30511C18.045 7.26011 17.94 7.26011 17.835 7.30511L17.7 7.36511L17.565 7.30511C17.46 7.26011 17.355 7.26011 17.25 7.30511L17.115 7.36511L16.98 7.30511C16.845 7.24511 16.68 7.26011 16.575 7.36511C16.47 7.47011 16.425 7.62011 16.47 7.75511L16.575 8.10011L16.485 8.31011C16.44 8.40011 16.44 8.52011 16.485 8.61011L16.575 8.80511L16.485 9.00011C16.44 9.09011 16.44 9.21011 16.485 9.30011L16.575 9.49511L16.485 9.69011C16.44 9.78011 16.44 9.90011 16.485 9.99011ZM17.325 9.34511L17.235 9.15011L17.325 8.95511C17.37 8.86511 17.37 8.74511 17.325 8.65511L17.235 8.46011L17.325 8.26511C17.355 8.20511 17.355 8.14511 17.355 8.08511L17.415 8.05511L17.55 8.11511C17.655 8.16011 17.76 8.16011 17.865 8.11511L18 8.05511L18.135 8.11511C18.24 8.16011 18.345 8.16011 18.45 8.11511L18.585 8.05511L18.645 8.08511C18.645 8.14511 18.645 8.22011 18.675 8.26511L18.765 8.46011L18.675 8.65511C18.63 8.74511 18.63 8.86511 18.675 8.95511L18.765 9.15011L18.675 9.34511C18.63 9.43511 18.63 9.55511 18.675 9.64511L18.765 9.84011L18.675 10.0351C18.645 10.0951 18.645 10.1551 18.645 10.2151L18.585 10.2451L18.45 10.1851C18.345 10.1401 18.24 10.1401 18.135 10.1851L18 10.2451L17.865 10.1851C17.82 10.1551 17.76 10.1551 17.7 10.1551C17.64 10.1551 17.595 10.1701 17.535 10.1851L17.4 10.2451L17.34 10.2151C17.34 10.1551 17.34 10.0801 17.31 10.0351L17.22 9.84011L17.31 9.64511C17.37 9.55511 17.37 9.45011 17.325 9.34511Z" fill={client?.defaultColor ? client.defaultColor : '#F288B7'}/>
                    <path d="M4.875 8.0249H7.965C8.175 8.0249 8.34 7.8599 8.34 7.6499C8.34 7.4399 8.175 7.2749 7.965 7.2749H4.875C4.665 7.2749 4.5 7.4399 4.5 7.6499C4.5 7.8599 4.665 8.0249 4.875 8.0249Z" fill={client?.defaultColor ? client.defaultColor : '#F288B7'}/>
                    <path d="M4.875 9.1499H7.965C8.175 9.1499 8.34 8.9849 8.34 8.7749C8.34 8.5649 8.175 8.3999 7.965 8.3999H4.875C4.665 8.3999 4.5 8.5649 4.5 8.7749C4.5 8.9849 4.665 9.1499 4.875 9.1499Z" fill={client?.defaultColor ? client.defaultColor : '#F288B7'}/>
                    <path d="M4.875 10.29H7.965C8.175 10.29 8.34 10.125 8.34 9.91504C8.34 9.70504 8.175 9.54004 7.965 9.54004H4.875C4.665 9.54004 4.5 9.70504 4.5 9.91504C4.5 10.11 4.665 10.29 4.875 10.29Z" fill={client?.defaultColor ? client.defaultColor : '#F288B7'}/>
                    <path d="M19.065 16.6502H12.255C12.045 16.6502 11.88 16.4852 11.88 16.2752V13.4702C11.88 13.2602 12.045 13.0952 12.255 13.0952H19.065C19.275 13.0952 19.44 13.2602 19.44 13.4702V16.2752C19.44 16.4852 19.275 16.6502 19.065 16.6502ZM12.63 15.9002H18.69V13.8452H12.63V15.9002Z" fill={client?.defaultColor ? client.defaultColor : '#F288B7'}/>
                  </svg>
                </span>
                {
                  pageUrl ? 
                    <Link to={pageUrl} className='text-dark'>Latest Mailers</Link>
                  :
                    <span>Latest Mailers</span>
                }
              </h4>

              <div>
                {
                  rows.length > 0 ?
                    rows.map((r, i) => {
                      return (
                        <div key={`smartsheet-direct-mail-summary-${i}`} className='mt-8 d-flex align-items-center'>
                          <div className='text-center w-40px'>{r?.dropDate && moment.unix(r?.dropDate.seconds).format('MM/DD')}<br/>{r?.dropDate && moment.unix(r?.dropDate.seconds).format('YYYY')}</div>
                          <div className='ms-6'>
                            <div className='mb-1'>
                              <span
                                className='fw-boldest cursor-pointer text-hover-primary'
                                data-bs-toggle='modal'
                                data-bs-target='#modal_smartsheet_direct_mail_summary_attachments'
                                onClick={() => {
                                  setAttachments(r?.attachments)
                                }}
                              >
                                {r?.title}
                              </span>
                            </div>
                            <div className='fs-0 fw-bold'>
                              {r?.jobCode && r?.jobCode.split('_')[0]}
                            </div>
                          </div>
                        </div>
                      )
                    })
                  :
                    <div className='mt-8'>No recent campaigns.</div>
                }
              </div>
            </div>
        }
      </div>

      <AttachmentsModal widget='smartsheet_direct_mail_summary' attachments={attachments} />
    </div>
  )
}

export default SmartsheetSummaryDirectMailWidget
